import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export async function getSystemSettings() {
  const data = await apiClient.get('/settings/system');

  return data;
}

export async function getSystemSetting(name: string) {
  const data: any = await apiClient.get(`/settings/system/${name}`);

  return data;
}

export async function updateSystemSetting(name: string, value: any) {
  const data = await apiClient.put(`/settings/system/${name}`, value);

  return data;
}
